export default "__VITE_ASSET__CEbdrLHl__"